import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaginationBaseService } from 'ng-lightquery';
import { DataSource } from '@angular/cdk/collections';
import { GetConversionError } from '../generated-client/generated-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConversionErrorsService extends PaginationBaseService<GetConversionError> implements DataSource<GetConversionError> {
  protected http: HttpClient;


  constructor() {
    const http = inject(HttpClient);

    super(http);
    this.http = http;

    this.baseUrl = '/api/conversion-errors';
    this.sort = { propertyName: 'dateUtc', isDescending: true };
  }

  connect(): Observable<GetConversionError[]> {
    return this.paginationResult
      .pipe(map(r => r.data));
  }

  disconnect() { }
}
